import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Veiculo } from "../../../../services/Veiculo";
import { IConsultaVeiculoPlacaForm } from "../../../../types/veiculo";

export const useConsultarVeiculoPorPlaca = () => {
  return useMutation({
    mutationFn: (data: IConsultaVeiculoPlacaForm) => Veiculo.postByPlaca(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
